import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { config } from "../../services/configHeader";

const baseUrl = process.env.REACT_APP_BASE_URI;

let initialState = {
  paymentLoading: false,
  paymentSuccess: false,
  paymentError: false,
  paymentMessage: null,
  paymentData: null,

  paymentGetLoading: false,
  paymentGetSuccess: false,
  paymentGetError: false,
  paymentGetMessage: null,
  paymentGetData: null,

  salaryLoading: false,
  salarySuccess: false,
  salaryError: true,
  salaryMessage: null,
  salaryData: null,
};


const user = localStorage.getItem("user_data")
  ? JSON.parse(localStorage.getItem("user_data"))
  : null;
const userId = user?.user_id;
const accountType = user?.account_type;

export const fetchPaymentHistoryData = createAsyncThunk(
  "fetchPaymentHistoryData",
  async (body) => {
    const { path, data } = body;
    return await axios
      .post(`${baseUrl}${path}`, data, config)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        if (!navigator.onLine) {
          let data = {
            response: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
            data: {
              data: [],
              message: "No Internet Connection Found",
              success: false,
            },
          };
          return data;
        } else {
          return error;
        }
      });
  }
);

export const savePaymentHistory = createAsyncThunk(
  "savePaymentHistory",
  async (body) => {
    const result = {
      data: {
        message: "Sorry, you can only view the data, not create it.",
        data: [],
      },
    };

    const { path, data } = body;
    const url = baseUrl + path;

    return parseInt(accountType) === 2
      ? result
      : await axios
          .post(`${url}`, data, config)
          .then((response) => {
            return response;
          })
          .catch((error) => {
            if (!navigator.onLine) {
              console.log(
                "You are offline. Please check your internet connection."
              );
            } else {
              console.log("An error occurred. Please try again later.", error);
            }
            let data = {
              response: {
                data: [],
                message: "No Internet Connection Found",
                success: false,
              },
            };
            return data;
          });
  }
);

export const calculateSalary = createAsyncThunk(
  "calculateSalary",
  async (body) => {
    const result = {
      data: {
        message: "Sorry, you can only view the data, not create it.",
        data: [],
      },
    };

    const { path, data } = body;
    const url = baseUrl + path;

    return parseInt(accountType) === 2
      ? result
      : await axios
          .post(`${url}`, data, config)
          .then((response) => {
            return response;
          })
          .catch((error) => {
            if (!navigator.onLine) {
              console.log(
                "You are offline. Please check your internet connection."
              );
            } else {
              console.log("An error occurred. Please try again later.", error);
            }
            let data = {
              response: {
                data: [],
                message: "No Internet Connection Found",
                success: false,
              },
            };
            return data;
          });
  }
);

const paymentHistorySlice = createSlice({
  name: "paymentHistory",
  initialState,

  reducers: {
    initPaymentState: (state) => {
      state.paymentLoading = false;
      state.paymentSuccess = false;
      state.paymentError = false;
      state.paymentMessage = null;
      state.paymentData = null;

      state.paymentGetLoading = false;
      state.paymentGetSuccess = false;
      state.paymentGetError = false;
      state.paymentGetMessage = null;

      state.salaryLoading = false;
      state.salarySuccess = false;
      state.salaryError = true;
      state.salaryMessage = null;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(fetchPaymentHistoryData.pending, (state, action) => {
      state.paymentGetLoading = true;
      state.paymentGetSuccess = false;
      state.paymentGetError = false;
      state.paymentGetMessage = null;
      state.paymentGetData = null;
    });
    builder.addCase(fetchPaymentHistoryData.fulfilled, (state, action) => {
      state.paymentGetLoading = false;
      state.paymentGetSuccess = true;
      state.paymentGetError = false;
      state.paymentGetMessage = action.payload.data.message;
      state.paymentGetData = action.payload.data;
    });
    builder.addCase(fetchPaymentHistoryData.rejected, (state, action) => {
      state.paymentGetLoading = false;
      state.paymentGetSuccess = false;
      state.paymentGetError = true;
      state.paymentGetMessage = action.payload.data.message;
      state.paymentGetData = null;
    });
    // To create attendance calculateSalary
    builder.addCase(calculateSalary.pending, (state, action) => {
      state.salaryLoading = true;
      state.salarySuccess = false;
      state.salaryError = false;
      state.salaryMessage = null;
      state.salaryData = null;
    });
    builder.addCase(calculateSalary.fulfilled, (state, action) => {
      if (action.payload.status == 200) {
        let status = action.payload.data.status;
        if (status) {
          state.salaryLoading = false;
          state.salarySuccess = accountType == 2 ? false : true;
          state.salaryError = accountType == 2 ? true : false;
          state.salaryMessage = action.payload.data.message;
          state.salaryData = action.payload.data.data;
        } else {
          state.salaryLoading = false;
          state.salarySuccess =
            accountType == 2 ? false : status ? true : false;
          state.salaryError = accountType == 2 ? true : status ? false : true;
          state.salaryMessage = action.payload.data.message;
          state.salaryData = action.payload.data.data;
        }
      } else {
        state.salaryLoading = false;
        state.salarySuccess = false;
        state.salaryError = true;
        state.salaryMessage = action.payload.response.message;
        state.salaryData = null;
      }
    });
    builder.addCase(calculateSalary.rejected, (state, action) => {
      state.salaryLoading = false;
      state.salarySuccess = false;
      state.salaryError = true;
      state.salaryMessage = "message";
      state.salaryData = null;
    });

    builder.addCase(savePaymentHistory.pending, (state, action) => {
      state.paymentLoading = true;
      state.paymentSuccess = false;
      state.paymentError = false;
      state.paymentMessage = null;
      state.paymentData = null;
    });
    builder.addCase(savePaymentHistory.fulfilled, (state, action) => {
      if (action.payload.status == 200) {
        let status = action.payload.data.status;
        if (status) {
          state.paymentLoading = false;
          state.paymentSuccess = accountType == 2 ? false : true;
          state.paymentError = accountType == 2 ? true : false;
          state.paymentMessage = action.payload.data.message;
          state.paymentData = action.payload.data.data;
        } else {
          state.paymentLoading = false;
          state.paymentSuccess =
            accountType == 2 ? false : status ? true : false;
          state.paymentError = accountType == 2 ? true : status ? false : true;
          state.paymentMessage = action.payload.data.message;
          state.paymentData = action.payload.data.data;
        }
      } else {
        state.paymentLoading = false;
        state.paymentSuccess = false;
        state.paymentError = true;
        state.paymentMessage = action.payload.response.message;
        state.paymentData = null;
      }
    });
    builder.addCase(savePaymentHistory.rejected, (state, action) => {
      state.paymentLoading = false;
      state.paymentSuccess = false;
      state.paymentError = true;
      state.paymentMessage = "message";
      state.paymentData = null;
    });
  },
});

export const { initPaymentState } = paymentHistorySlice.actions;

export default paymentHistorySlice.reducer;
